import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedServicesService } from '../shared/sharedservices/shared-services.service';
import { ResourceDto } from '../Models/ResourceDto';
import { LoginService } from '../landing/login.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-access-error',
  templateUrl: './access-error.component.html',
  styleUrls: ['./access-error.component.scss'],
  encapsulation: ViewEncapsulation.None  // to enable styles in innerHTML
})
export class AccessErrorComponent implements OnInit {

  resource: ResourceDto;
  msgSubscription: Subscription;
  errorMessage: string = '';
  // `<div class="appLayout accessError">  
  //   <p>
  //     <img class="appImg" src="../../assets/images/exclam-yellow-75.png" alt="NoAccess"/>
  //   </p>
  //   <p class="errorHeading">
  //     Access Role is not configured.
  //   </p>
  //   <p class="errorText">
  //     <br /> 
  //     If your country and service line is listed <a href="https://sites.ey.com/sites/MERAGlobal/SitePages/Deployed-Countries-by-Service-Line.aspx" target = "_blank"><u>here</u></a>, please clear browser cache and try again.
  //     <br/>
  //     If you still receive the same error message, please contact the IT Helpdesk.
  //     <br/><br/>
  //     If you need Resource/Experience Manager access role then contact your Resourcing/Experience Management team.
  //   </p>
  // </div>`;
  
  constructor(public sharedService: SharedServicesService, private loginService : LoginService) { 
    
  }

  ngOnInit() {    
    this.resource = new ResourceDto();
    // refresh Header & Footer
    this.sharedService.setHeaderDetails(this.resource);
    this.sharedService.setFooterDetails(this.resource);
    this.loginService.setMenuHideAndShow(false);
    

    this.errorMessage = sessionStorage.getItem('RoleAccessError');
    if (!this.errorMessage) {
      this.getStaticContent();
    }
    else {
      sessionStorage.removeItem('RoleAccessError');
    }
  }

  getStaticContent() {
    this.msgSubscription =
    this.sharedService.getStaticContent('RoleAccessError').subscribe((data: any) => {
      this.errorMessage = data.body.customData.contentValue;
    });
  }
}
